import { LayoutActionTypes } from "./constants";

export const setLoading = (bool) => ({
  type: LayoutActionTypes.SET_LOADING,
  payload: bool,
});

export const setShowNavigationMenu = (bool) => ({
  type: LayoutActionTypes.SHOW_NAVIGATION_MENU,
  payload: bool,
});

export const setDisableNavigation = (bool) => ({
  type: LayoutActionTypes.DISABLE_NAVIGATION,
  payload: bool,
});

export const setLanguage = (language) => ({
  type: LayoutActionTypes.SET_LANGUAGE,
  payload: language,
});

export const setTranslations = (translations) => ({
  type: LayoutActionTypes.SET_TRANSLATIONS,
  payload: translations,
});

export const setShowLanguageMenu = (bool) => ({
  type: LayoutActionTypes.SET_SHOW_LANGUAGE_MENU,
  payload: bool,
});

export const setLayoutShowErrorMessage = (header, text) => ({
  type: LayoutActionTypes.SET_SHOW_ERROR_MESSAGE,
  payload: { header, text },
});

export const setLayoutShowError = (bool) => ({
  type: LayoutActionTypes.SET_SHOW_ERROR,
  payload: bool,
});

export const setLanguageOptions = (options) => ({
  type: LayoutActionTypes.SET_LANGUAGE_OPTIONS,
  payload: options,
});
